import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/landing.css';

// No <StrictMode>. Its development double-invoke would run the i18n effects
// twice against window.i18nTranslator, which rewrites the innerHTML of mounted
// [data-i18n] nodes in place — a second reset/translate pass over a tree React
// believes is settled is exactly the interleaving components/T.jsx warns about.
createRoot(document.getElementById('root')).render(<App />);
